// extracted by mini-css-extract-plugin
export var carouselItemWrapperStyle = "carousel_item_new-module--carouselItemWrapperStyle--Vqc8U";
export var imageWrapperStyle = "carousel_item_new-module--imageWrapperStyle--N5mLj";
export var textWrapperStyle = "carousel_item_new-module--textWrapperStyle--0aFuH";